import ActionButtons from '@/components/organisms/ActionButtons';
import Footer from '@/components/organisms/Footer';
import TopNavigation from '@/components/organisms/TopNavigation';
import { Alternate, LangContext, languageSwitchTarget, resolveLang } from '@/i18n';
import { MergeProps } from '@devsisters/wds-react';
import { PageProps } from 'gatsby';
import React from 'react';

type BaseProps = {
  children?: React.ReactNode;
};
type Props = MergeProps<PageProps, BaseProps>;
function RootLayout(props: Props) {
  const { location, pageContext, children } = props;
  const lang = resolveLang(pageContext, location.pathname);
  const alternates = (pageContext as { alternates?: Alternate[] })?.alternates;
  const switchTarget = languageSwitchTarget(lang, alternates);

  return (
    <LangContext.Provider value={lang}>
      <TopNavigation location={location} languageSwitch={switchTarget} />
      {children}

      <ActionButtons />
      <Footer />
    </LangContext.Provider>
  );
}

export default RootLayout;
